import type {GetAllBuildTypesApiArg, GetBuildTypeApiArg} from '../services/rest'
import {stringifyId} from '../types'
import type {BuildTypeId, RequestOptionsParams} from '../types'

export const BuildTypeProperties = {
  RUN_BUTTON_CAPTION: 'teamcity.ui.runButton.caption',
  DEFAULT_BUILDTYPE_TAB: 'teamcity.ui.buildType.defaultTab',
  DEFAULT_PROJECT_TAB: 'teamcity.ui.project.defaultTab',
  PROMOTE_ONLY: 'teamcity.buildType.environmentBuildType.promoteOnly',
}
const descriptionField = 'description'
const pauseCommentField = 'pauseComment(text,timestamp,user(username,name,id,avatars))'
export const linksField = 'links(link(type,relativeUrl))'
export const linksAvailabilityField = 'links(link(type))'
export const parametersField =
  'parameters($locator(name(matchType:starts-with,value:teamcity)),property(name,value))'
const snapshotDependenciesField = 'snapshot-dependencies(snapshot-dependency(id))'
const shortProjectDetailsField = 'project(id,name,virtual,parentProjectId,holdsPipeline)'
const basicBuildTypeFields = [
  'id',
  'paused',
  'internalId',
  'projectId',
  'projectInternalId',
  'name',
  'type',
]
export const buildTypeFields: (options?: RequestOptionsParams) => ReadonlyArray<string> = options =>
  basicBuildTypeFields
    .concat(
      options?.withLinks === true
        ? linksField
        : options?.withLinksAvailability === true
          ? linksAvailabilityField
          : [],
    )
    .concat(options?.withParameters === true ? parametersField : [])
    .concat(options?.withDescription === true ? descriptionField : [])
    .concat(options?.withSnapshotDependencies === true ? snapshotDependenciesField : [])
    .concat(options?.withPauseComment === true ? pauseCommentField : [])
    .concat(options?.withShortProjectDetails === true ? shortProjectDetailsField : [])

export const getBuildTypeArg = (
  buildTypeId: BuildTypeId,
  options: RequestOptionsParams = {
    withLinks: true,
    withParameters: true,
    withDescription: true,
    withPauseComment: true,
  },
): GetBuildTypeApiArg => ({
  btLocator: `id:${buildTypeId}`,
  fields: buildTypeFields(options).join(','),
  essential: true,
})

export const getBuildTypesArg = (
  locator: string,
  options?: RequestOptionsParams,
): GetAllBuildTypesApiArg => ({
  locator,
  fields: `buildType(${buildTypeFields(options).join(',')})`,
})

export const getDependantsLocator = (buildTypeId: BuildTypeId): string =>
  `snapshotDependency(from:(id:${stringifyId(buildTypeId)}))`
